import { SubscriptionInterface } from '@app/models/subscription';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import DocSearchIcon from '@app/assets/icons/doc-search.svg?react';
import IphoneIcon from '@app/assets/icons/iphone.svg?react';
import RefreshIcon from '@app/assets/icons/refresh.svg?react';
import DiamondIcon from '@app/assets/icons/diamond.svg?react';

export const PlanCard = ({
  businessSubscription,
  hideHeader,
}: {
  businessSubscription?: SubscriptionInterface;
  hideHeader?: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white p-4 h-fit">
      {!hideHeader && (
        <>
          <div className="flex items-center justify-between">
            <h5 className="font-bold text-sm">Your current plan</h5>
            <button onClick={() => navigate('/settings/plan/details')} className="bg-base-antiFlash p-2 rounded-lg flex gap-2 items-center text-sm">
              <span>View more</span>
              <DocSearchIcon />
            </button>
          </div>
          <hr className="my-4 border-base-ghostWhite" />
        </>
      )}
      <div className="w-full h-40 flex justify-between flex-col bg-gradient-to-r from-gradient-baseBlue from-[-15%]  to-gradient-ufoGreen to-[113%] rounded-xl text-white p-4">
        <p className="text-xs font-extrabold flex gap-2 items-center">
          <DiamondIcon />{' '}
          <span className="capitalize">
            {businessSubscription?.plan?.type === 'BASIC'
              ? 'Starter Plan'
              : businessSubscription?.plan?.type
                ? businessSubscription.plan.type.charAt(0).toUpperCase() +
                  businessSubscription.plan.type.slice(1).toLowerCase() +
                  ' Plan'
                : ''}
          </span>
        </p>
        <p className="font-bold text-4xl text-brand-lightBlue4">${businessSubscription?.plan?.price}</p>
        <p className="text-sm font-medium">Price per month</p>
      </div>
      {/*<pre style={{ border: 'solid 1px red', textAlign: 'left' }}>{JSON.stringify(businessSubscription, null, 4)}</pre>*/}
      <table className="my-4">
        <tbody>
          {businessSubscription?.trialEnd && (
            <tr>
              <td className="uppercase flex items-center gap-2 py-2 w-[160px]">
                <span className="bg-base-antiFlash p-1 rounded-md">
                  <IphoneIcon />
                </span>
                <span className="text-base-coolGray font-medium text-xs">discount name</span>
              </td>
              <td>
                <span className="font-medium text-sm">Free trial - {Math.max(0, Math.ceil((businessSubscription.trialEnd - DateTime.now().toUnixInteger()) / (24 * 60 * 60)))} days left</span>
              </td>
            </tr>
          )}
          <tr>
            <td className="uppercase flex items-center gap-2 py-2 w-[160px]">
              <span className="bg-base-antiFlash p-1 rounded-md">
                <RefreshIcon />
              </span>
              <span className="text-base-coolGray font-medium text-xs">next invoice</span>
            </td>
            <td>
              <span className="font-medium text-sm">
                {(() => {
                  const invoiceDate = businessSubscription?.trialEnd
                    ? DateTime.fromSeconds(businessSubscription.trialEnd)
                    : businessSubscription?.endDate
                      ? DateTime.fromISO(businessSubscription.endDate)
                      : null;

                  if (!invoiceDate) return 'N/A';

                  if (invoiceDate.isValid) {
                    const day = invoiceDate.day;
                    const suffix = day === 1 || day === 21 || day === 31 ? 'st' : day === 2 || day === 22 ? 'nd' : day === 3 || day === 23 ? 'rd' : 'th';
                    return `${day}${suffix} of ${invoiceDate.toFormat('MMMM, yyyy')}`;
                  }

                  return 'Invalid date';
                })()}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
